import styled from "styled-components";
import { useTranslation } from "react-i18next";

const ProfileBoxContainer = styled.div`
  border-bottom: 1px solid rgb(229, 229, 229);
`;

const ImageContainer = styled.div`
 
  border-radius: 0px 24px;
  width: 264px;
  margin: 0px auto;
`;

const NameContainer = styled.p`
  font-weight: bold;
  font-size: 20px;
  color: rgb(94, 81, 77);
`;

const JabatanContainer = styled.p`
  font-size: 18px;
  color: rgb(94, 81, 77);
`;

const PengalamanContainer = styled.div`
  font-family: KBFGDisplay;
  font-weight: bold;
  font-size: 16px;
  color: rgb(94, 81, 77);

  & p {
    font-family: KBFGDisplay;
    font-weight: bold;
    font-size: 16px;
    color: rgb(94, 81, 77);
  }

  & ::marker {
    unicode-bidi: isolate;
    font-variant-numeric: tabular-nums;
    text-transform: none;
    text-indent: 0px !important;
    text-align: start !important;
    text-align-last: start !important;
  }

  & ul li {
      font-weight: 400;
  }
`;

const LandingCardBox = function (props) {
  const { t } = useTranslation();

  return (
    <ProfileBoxContainer className='py-3'>
      <div className='d-flex flex-column flex-lg-row'>
        <div className='center mb-4 d-flex justify-content-center me-lg-4'>
          <ImageContainer>
            <img
              src={props.imageDataDesktop}
              alt={props.nama}
              width="100%"
            />
          </ImageContainer>
        </div>
        <div className="align-items-lg-center">
          <NameContainer>{props.nama}</NameContainer>
          <JabatanContainer>{props.jabatan}</JabatanContainer>
          <PengalamanContainer
            dangerouslySetInnerHTML={{ __html: props.description }}
          />
        </div>
      </div>
    </ProfileBoxContainer>
  );
};

export default LandingCardBox;
